var map = {
	"./Pin-Dark-Delegacia.svg": 650,
	"./Pin-Dark-Moto.svg": 651,
	"./Pin-Dark-Ocorrencia.svg": 652,
	"./Pin-Dark-Policial.svg": 653,
	"./Pin-Dark-Viatura.svg": 654,
	"./Pin-Light-Delegacia.svg": 655,
	"./Pin-Light-Moto.svg": 656,
	"./Pin-Light-Ocorrencia.svg": 657,
	"./Pin-Light-Policial.svg": 658,
	"./Pin-Light-Viatura.svg": 659
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1216;